import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { landingApi } from "../api/landingApi";
import { useAuth } from "../components/AuthContext";

export default function PaymentTransitions() {
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formData, setFormData] = useState({
    amount: 0,
    currency: "mmk",
    orderType: "plan_merchant",
    // orderId: 10,
    platform: "web",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [paymentPayload, setPaymentPayload] = useState(null);
  const { merchantId, authToken } = useAuth();
  const [planId, setPlanId] = useState();
  const [autoProcessing, setAutoProcessing] = useState(false);

  // Read payment amount from localStorage when component mounts
  useEffect(() => {
    let paymentAmount = localStorage.getItem("amount");
    const cartItemString = localStorage.getItem("cartItem");
    let cartItem = null;
    let orderType = null;

    if (cartItemString) {
      try {
        cartItem = JSON.parse(cartItemString);
        if (cartItem && cartItem.addonType) {
          orderType = cartItem.addonType;
        }
        if (cartItem && cartItem.price && !paymentAmount) {
          paymentAmount = cartItem.price;
        }
      } catch (error) {
        console.error("error parsing cartitem form localstorage:", error);
      }
    }

    const planId = localStorage.getItem("planId");
    setPlanId(planId);
    // const paymentAddonType = localStorage.getItem("paymentAddonType");
    // const paymentAddonTypeId = localStorage.getItem("paymentAddonTypeId");

    if (paymentAmount) {
      setFormData((prev) => ({
        ...prev,
        amount: parseInt(paymentAmount) || paymentAmount,
        currency: prev.currency,
        // orderId: paymentOrderId ? parseInt(paymentOrderId) : prev.orderId,
        orderType: orderType || prev.orderType,
      }));
    }

    // Check for pre-selected payment method from route state or localStorage
    const preSelectedPaymentMethod = location.state?.paymentMethod || localStorage.getItem("selectedPaymentMethod");
    const stateAmount = location.state?.amount;
    const statePlanId = location.state?.planId || location.state?.membership?.planId;
    const shouldChangePayment = location.state?.changePayment === true;

    if (stateAmount) {
      setFormData((prev) => ({
        ...prev,
        amount: parseInt(stateAmount) || stateAmount,
      }));
    }
    if (statePlanId) {
      setPlanId(statePlanId);
    }

    // Auto-process payment if payment method is pre-selected and not changing payment
    if (preSelectedPaymentMethod && !paymentPayload && !autoProcessing && !shouldChangePayment) {
      setSelectedCategory(preSelectedPaymentMethod);
      setAutoProcessing(true);
      handleAutoPayment(preSelectedPaymentMethod, stateAmount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto-process payment when payment method is pre-selected
  const handleAutoPayment = async (preSelectedCategory, amount) => {
    setLoading(true);
    setError("");
    setPaymentPayload(null);

    try {
      const data = await landingApi.processPayment(
        merchantId,
        {
          ...formData,
          amount: amount || formData.amount,
          // orderId: planId,
          // paymentMethod: paymentMethod,
          redirect_url: `${window.location.origin}/paymentSuccess`, // Adjust URL as needed
        },
        authToken,
      );

      console.log("res data:", data);

      // Store transaction details in localStorage for success page
      const transactionDetails = {
        orderId: planId || formData.orderId,
        amount: amount || formData.amount,
        currency: formData.currency,
        paymentMethod: getCategoryName(preSelectedCategory),
        timestamp: new Date().toISOString(),
        platform: formData.platform,
      };
      localStorage.setItem(
        "transactionDetails",
        JSON.stringify(transactionDetails),
      );

      setPaymentPayload(data);
      setAutoProcessing(false);
    } catch (err) {
      console.error("API Error Details:", err);
      console.error("Response Data:", err.response?.data);
      console.error("Response Status:", err.response?.status);
      setError(err.message || "An error occurred");
      setLoading(false);
      setAutoProcessing(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCategory) {
      setError("Please select a payment method");
      return;
    }

    setLoading(true);
    setError("");
    setPaymentPayload(null);

    // Map category to payment method
    // const paymentMethodMap = {
    //   international: "visa",
    //   mobile: "mmqr",
    // };

    // const paymentMethod =
    //   paymentMethodMap[selectedCategory] || selectedCategory;

    try {
      // Store selected payment method in localStorage for future visits
      localStorage.setItem("selectedPaymentMethod", selectedCategory);

      const data = await landingApi.processPayment(
        merchantId,
        {
          ...formData,
          amount: formData.amount,
          // orderId: planId,
          // paymentMethod: paymentMethod,
          redirect_url: `${window.location.origin}/paymentSuccess`, // Adjust URL as needed
        },
        authToken,
      );

      console.log("res data:", data);

      // Store transaction details in localStorage for success page
      const transactionDetails = {
        orderId: planId || formData.orderId,
        amount: formData.amount,
        currency: formData.currency,
        paymentMethod: getCategoryName(selectedCategory),
        timestamp: new Date().toISOString(),
        platform: formData.platform,
      };
      localStorage.setItem(
        "transactionDetails",
        JSON.stringify(transactionDetails),
      );

      setPaymentPayload(data);
    } catch (err) {
      console.error("API Error Details:", err);
      console.error("Response Data:", err.response?.data);
      console.error("Response Status:", err.response?.status);
      setError(err.message || "An error occurred");
      setLoading(false);
    }
  };

  // If we have payment payload, show the CyberSource form
  if (paymentPayload) {
    return (
      <div className="max-w-lg mx-auto mt-8 p-8 bg-white rounded-2xl shadow-xl border border-green-100">
        <div className="text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="text-2xl">🔒</span>{" "}
            {/* Replaced Lock icon with emoji */}
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Redirecting to Payment...
          </h1>
          <p className="text-gray-600 mb-6">
            You will be redirected to the payment gateway to complete your
            transaction securely.
          </p>
        </div>

        <form
          id="cybersource-form"
          method="post"
          action="https://testsecureacceptance.cybersource.com/pay"
          className="hidden"
        >
          {Object.entries(paymentPayload).map(([key, value]) => (
            <input type="hidden" name={key} value={String(value)} key={key} />
          ))}
        </form>

        <button
          type="button"
          onClick={() => {
            const form = document.getElementById("cybersource-form");
            if (form) {
              form.submit();
            }
          }}
          className="w-full bg-green-600 text-white py-3 px-6 rounded-xl font-semibold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
        >
          <span className="text-sm">💳</span> {/* Replaced CreditCard icon */}
          Proceed to Payment Gateway
        </button>
      </div>
    );
  }

  // Define payment categories
  const paymentCategories = [
    { id: "international", name: "Visa/ Master", icon: "💳" },
    { id: "mobile", name: "MMQR", icon: "📱" },
  ];

  // Get category name by ID
  const getCategoryName = (id) => {
    const cat = paymentCategories.find((c) => c.id === id);
    return cat?.name || "";
  };

  // Initial form to get payment payload
  return (
    <div className="max-w-2xl mx-auto mt-8 p-6">
      {/* Payment Summary Card */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-6 mb-6 text-white">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-blue-100 text-sm font-medium">Amount to Pay</p>
            <p className="text-3xl font-bold">
              {formData.amount.toLocaleString()} MMK
            </p>
          </div>
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <span className="text-xl">💳</span> {/* Replaced CreditCard icon */}
          </div>
        </div>
      </div>

      {/* Payment Method Selection */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
          <span className="text-lg">🌐</span> {/* Replaced Globe icon */}
          Select Payment Method
          <span className="text-red-500">*</span>
        </h2>

        {/* Payment Method Options - Clickable Cards */}
        <div className="grid grid-cols-2 gap-4">
          {paymentCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`p-4 rounded-xl border-2 transition-all duration-200 flex flex-col items-center gap-2 ${
                selectedCategory === category.id
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
              }`}
            >
              <span className="text-3xl">{category.icon}</span>
              <span
                className={`font-medium ${
                  selectedCategory === category.id
                    ? "text-blue-700"
                    : "text-gray-700"
                }`}
              >
                {category.name}
              </span>
            </button>
          ))}
        </div>

        {/* Selected Payment Method Display with Success */}
        {selectedCategory && (
          <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-xl">
            <p className="text-green-700 font-medium flex items-center gap-2">
              <span className="text-green-600">✓</span>
              Selected: <strong>{getCategoryName(selectedCategory)}</strong>
            </p>
          </div>
        )}
      </div>

      {/* Payment Details Form */}
      <div className="bg-white rounded-2xl shadow-sm p-6 mt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <button
            type="submit"
            disabled={loading || !selectedCategory}
            className={`w-full py-4 px-6 rounded-xl font-semibold text-white transition-all duration-200 flex items-center justify-center gap-2 ${
              selectedCategory
                ? "bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-xl"
                : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            {loading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Processing...
              </>
            ) : (
              <>
                <span className="text-sm">🔒</span> {/* Replaced Lock icon */}
                Pay {formData.amount.toLocaleString()} MMK
              </>
            )}
          </button>
        </form>

        {error && (
          <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl">
            <p className="text-red-700 text-sm">{error}</p>
          </div>
        )}
      </div>

      <div className="mt-6 text-center text-gray-500 text-sm">
        <p className="flex items-center justify-center gap-2">
          <span className="text-sm">🔒</span> {/* Replaced Lock icon */}
          Your payment is secured with 256-bit SSL encryption
        </p>
      </div>
    </div>
  );
}
